import React from 'react'

export default function Footer({ visits }) {
  return (
    <footer className="border-t border-card-border mt-8">
      <div className="container py-6 flex justify-center">
        <span className="font-mono text-[0.72rem] text-subtle">
          © 2026 Huy Phu. All rights reserved. | Views: {visits}
        </span>
      </div>
    </footer>
  )
}
